import * as React from 'react';
import Button from 'src/components/Button';

import { IDocument, IOrderQuantities_Addresses, IState } from '../../../../infrastructure/interfaces';
import ShippingInfoForm from '../../../Modals/ShippingInfoForm';

export interface IShippingInfoInteractiveFormProps {
  onFieldChange: any;
  onDocumentNameFieldChange: any;
  onOrderCommentsFieldChange: any;
  onSelectedEditOrderQuantityAddressPair(itemIndex: number): void;
  onSelectedDeleteOrderQuantityAddressPair(itemIndex: number): void;
  document: IDocument;
  comments: string;
  orderQuantityAddressPairs: IOrderQuantities_Addresses[];
  selectedOrderQuantityAddressPair: IOrderQuantities_Addresses;
  orderQuantityAddressPairIndex: number;
  statesList: IState[];
}

export interface IShippingInfoInteractiveFormState {
  document: IDocument;
}

export default class ShippingInfoInteractiveForm extends React.Component<IShippingInfoInteractiveFormProps, IShippingInfoInteractiveFormState> {
  constructor(props: IShippingInfoInteractiveFormProps) {
    super(props);
  }

  render() {
    return (
      <div className="shippingInfoContainer interactive">
        <div className="shippingInfoInputContainer">
          <label>
            Document Name
          </label>
          <input
            className="companyInfoInput settingCompanyInfoInput"
            type="text"
            name="documentName"
            value={this.props.document.name}
            onChange={this.props.onDocumentNameFieldChange}
          />
        </div>
        <div className="shippingInfoInputContainer">
          <label>
            Order Comments
          </label>
          <textarea
            className="companyInfoInput settingCompanyInfoInput"
            name="comments"
            value={this.props.comments}
            onChange={this.props.onOrderCommentsFieldChange}
          />
        </div>
        <div className="mainSectorHead">
          <h5>
            Shipping Information
              <span>Please enter required shipping information. Your order cannot be submitted without it.</span>
          </h5>
        </div>
        {
          ((this.props.orderQuantityAddressPairs.length > 0) || (this.props.orderQuantityAddressPairIndex < 0)) ? (
            this.props.orderQuantityAddressPairs.map((addressQuantityPair, index) => (
              (index == this.props.orderQuantityAddressPairIndex) ?
                <ShippingInfoForm
                  onFieldChange={this.props.onFieldChange}
                  document={this.props.document}
                  statesList={this.props.statesList}
                  selectedOrderQuantityAddressPair={addressQuantityPair}
                  key={index}
                />
                :
                <div className="admin-shipping-container" key={index}>
                  <div className="manage-shipping-table">
                    <div>
                      <div>Address</div>
                      <div>
                        {addressQuantityPair.address.shipName}<br/>
                        {addressQuantityPair.address.shipAddress1} {addressQuantityPair.address.shipAddress2}<br/>
                        {addressQuantityPair.address.shipCity}, {addressQuantityPair.address.shipState} {addressQuantityPair.address.shipPostalCode}<br/>
                        {addressQuantityPair.address.shipCountry}<br/>
                        <br/>
                      </div>
                      <div>Quantity</div>
                      <div>{addressQuantityPair.orderQuantity}</div>
                      <div>
                        <Button
                          bsClass="edit"
                          onClick={() => {
                            this.props.onSelectedEditOrderQuantityAddressPair(index)
                          }}
                        >
                          Edit
                        </Button>

                        {(this.props.orderQuantityAddressPairs.length > 1)
                          ? (<Button
                            bsClass="delete"
                            onClick={() => {
                              this.props.onSelectedDeleteOrderQuantityAddressPair(index);
                            }}
                          >
                            Delete
                          </Button>)
                        : (<div></div>)
                        }
                      </div>
                    </div>
                  </div>
                </div>
            ))
          )
          : (
            <ShippingInfoForm
              onFieldChange={this.props.onFieldChange}
              document={this.props.document}
              statesList={this.props.statesList}
              selectedOrderQuantityAddressPair={this.props.selectedOrderQuantityAddressPair}
            />
          )
        }
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/OrderPrintsModal/Components/ShippingInfoInteractiveForm.tsx